/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideZadWorkspaceMenu} from './AsideZadWorkspaceMenu'
import './asideAccountingMenu.css'
import useAuth from '../../../../hooks/useAuth'
import useMaarefatiWorkspace from '../../../../hooks/useMaarefatiWorkspace'
import {
  getRolePathPrefixes,
  hasPayrollV2LegalDraftAccess,
  hasPayrollV2NavAccess,
  hasSchoolAccountingDashboardAccess,
  hasSchoolAccountingEmailTemplateAdminAccess,
  hasSchoolAccountingReceiptsAccess,
  hasSchoolAccountingStudentOutstandingAccess,
  hasSchoolAccountingTicketsAccess,
} from '../../../../roles'

export function AsideMenuMain() {
  const intl = useIntl()
  const {me} = useAuth()
  const workspace = useMaarefatiWorkspace()
  
  const pathPrefixes = getRolePathPrefixes(me?.role ?? null)
  const hasRoleAccess = (path: string) => Boolean(pathPrefixes?.includes(path))

  return (
    <>
      {/* <AsideMenuItem
        to='/licenses'
        icon='/media/icons/duotune/general/gen019.svg'
        title={intl.formatMessage({id: 'MENU.LICENSES'})}
        fontIcon='bi-layers'
  /> */}
      {me && pathPrefixes ? (
        <>
          {workspace.showZadSidebar ? (
            <AsideZadWorkspaceMenu
              hasRoleAccess={hasRoleAccess}
              showBackToMaarefati={workspace.showBackToMaarefati}
              maarefatiLandingPath={workspace.maarefatiLandingPath}
            />
          ) : (
            <></>
          )}
          {workspace.showMaarefatiSidebar && (
            !hasRoleAccess('/zad') && (hasRoleAccess('/zad/reports/accounting') || hasRoleAccess('/zad/sales-history')) ? (
            <>
              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                    {intl.formatMessage({id: 'ZAD.MENU.FINANCE_SECTION'})}
                  </span>
                </div>
              </div>
              {hasRoleAccess('/zad/sales-history') ? (
                <AsideMenuItem
                  to='/zad/sales-history'
                  icon='/media/icons/duotune/graphs/gra001.svg'
                  title={intl.formatMessage({id: 'ZAD.MENU.SALES_HISTORY'})}
                  fontIcon='bi-clock-history'
                />
              ) : null}
              {hasRoleAccess('/zad/reports/accounting') ? (
              <AsideMenuItem
                to='/zad/reports/accounting'
                icon='/media/icons/duotune/finance/fin006.svg'
                title={intl.formatMessage({id: 'ZAD.MENU.ACCOUNTING_REPORT'})}
                fontIcon='bi-journal-text'
              />
              ) : null}
            </>
          ) : (
            <></>
          )
          )}
          {workspace.showMaarefatiSidebar ? (
          <>
          {hasRoleAccess('/info-center') ? (
            <AsideMenuItem
              to='/info-center'
              icon='/media/icons/duotune/general/gen021.svg'
              title={intl.formatMessage({id: 'MENU.INFO_CENTER'})}
              fontIcon='bi-info-circle'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/establishements') ? (
            <AsideMenuItem
              to='/establishements'
              icon='/media/icons/duotune/ecommerce/ecm008.svg'
              title={intl.formatMessage({id: 'MENU.ESTABLISHEMENTS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/classes') ? (
            <AsideMenuItem
              to='/classes'
              icon='/media/icons/duotune/art/art002.svg'
              title={intl.formatMessage({id: 'MENU.CLASSES'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/users') ? (
            <AsideMenuItem
              to='/users'
              icon='/media/icons/duotune/communication/com006.svg'
              title={intl.formatMessage({id: 'MENU.USERS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/kids') ? (
            <AsideMenuItem
              to='/kids'
              icon='/media/icons/duotune/general/gen049.svg'
              title={intl.formatMessage({id: 'MENU.KIDS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/subjects') ? (
            <AsideMenuItem
              to='/subjects'
              icon='/media/icons/duotune/art/art002.svg'
              title={intl.formatMessage({id: 'MENU.SUBJECTS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/exercices') ? (
            <AsideMenuItem
              to='/exercices'
              icon='/media/icons/duotune/general/gen055.svg'
              title={intl.formatMessage({id: 'MENU.EXERCICES'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/video-gallery') ? (
            <AsideMenuItem
              to='/video-gallery'
              icon='/media/icons/duotune/general/gen014.svg'
              title={intl.formatMessage({id: 'MENU.VIDEO_GALLERY'})}
              fontIcon='bi-play-circle'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/ranking-board') ? (
            <AsideMenuItem
              to='/ranking-board'
              icon='/media/icons/duotune/general/gen049.svg'
              title={intl.formatMessage({id: 'INFO_CENTER.LEADERBOARD.TITLE', defaultMessage: 'Ranking Board'})}
              fontIcon='bi-trophy'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/inventory') ? (
            <AsideMenuItem
              to='/inventory'
              icon='/media/icons/duotune/general/gen025.svg'
              title={intl.formatMessage({id: 'MENU.INVENTORY'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/inventory-types') ? (
            <AsideMenuItem
              to='/inventory-types'
              icon='/media/icons/duotune/general/gen026.svg'
              title={intl.formatMessage({id: 'MENU.INVENTORY_TYPES'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/inventory-statistics') ? (
            <AsideMenuItem
              to='/inventory-statistics'
              icon='/media/icons/duotune/graphs/gra010.svg'
              title={intl.formatMessage({id: 'MENU.INVENTORY_STATISTICS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/exams') ? (
            <AsideMenuItem
              to='/exams'
              icon='/media/icons/duotune/coding/cod002.svg'
              title={intl.formatMessage({id: 'MENU.EXAMS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {/* Same audience as Events & Exams: show if role lists `/national-exams` or `/exams` (keeps menu in sync with route guard). */}
          {hasRoleAccess('/national-exams') || hasRoleAccess('/exams') ? (
            <AsideMenuItem
              to='/national-exams'
              icon='/media/icons/duotune/files/fil025.svg'
              title={intl.formatMessage({
                id: 'MENU.NATIONAL_EXAMS',
                defaultMessage: 'National exams',
              })}
              fontIcon='bi-journal-text'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/admin-documents') ? (
            <AsideMenuItem
              to='/admin-documents'
              icon='/media/icons/duotune/files/fil002.svg'
              title={
                me?.role === '2' || me?.role === '6' || me?.role === '10'
                  ? intl.formatMessage({
                      id: 'MENU.ADMIN_DOCUMENTS',
                      defaultMessage: 'Official documents',
                    })
                  : intl.formatMessage({
                      id: 'MENU.MY_DOCUMENTS',
                      defaultMessage: 'My documents',
                    })
              }
              fontIcon='bi-file-earmark-text'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/remarques') ? (
            <AsideMenuItem
              to='/remarques'
              icon='/media/icons/duotune/communication/com007.svg'
              title={intl.formatMessage({id: 'MENU.REMARQUES'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/grades') ? (
            <AsideMenuItem
              to='/grades'
              icon='/media/icons/duotune/files/fil016.svg'
              title={intl.formatMessage({id: 'MENU.GRADES'})}
              fontIcon='bi-clipboard-check'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/type-exams') ? (
            <AsideMenuItem
              to='/type-exams'
              icon='/media/icons/duotune/general/gen019.svg'
              title={intl.formatMessage({id: 'MENU.TYPE_EXAMS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/type-remarques') ? (
            <AsideMenuItem
              to='/type-remarques'
              icon='/media/icons/duotune/files/fil016.svg'
              title={intl.formatMessage({id: 'MENU.TYPE_REMARQUES'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/payment-categories') ? (
            <AsideMenuItem
              to='/payment-categories'
              icon='/media/icons/duotune/finance/fin006.svg'
              title={intl.formatMessage({id: 'MENU.PAYMENT_CATEGORIES'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/payments') ? (
            <AsideMenuItem
              to='/payments'
              icon='/media/icons/duotune/finance/fin007.svg'
              title={intl.formatMessage({id: 'MENU.PAYMENTS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/billing') ? (
            <AsideMenuItem
              to='/billing'
              icon='/media/icons/duotune/finance/fin008.svg'
              title={intl.formatMessage({id: 'MENU.BILLING'})}
              fontIcon='bi-wallet2'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/payroll') ? (
            <AsideMenuItem
              to='/payroll'
              icon='/media/icons/duotune/finance/fin006.svg'
              title={intl.formatMessage({id: 'MENU.PAYROLL'})}
              fontIcon='bi-receipt-cutoff'
              exact
            />
          ) : (
            <></>
          )}

          {hasPayrollV2NavAccess(me?.role) ? (
            <AsideMenuItemWithSub
              to='/payroll/v2'
              icon='/media/icons/duotune/finance/fin001.svg'
              title={intl.formatMessage({id: 'PAYROLL_V2.MENU.ROOT'})}
              fontIcon='bi-calculator'
            >
              <AsideMenuItem to='/payroll/v2' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.DASHBOARD'})} hasBullet exact />
              <AsideMenuItem to='/payroll/v2/employees' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.EMPLOYEES'})} hasBullet />
              <AsideMenuItem to='/payroll/v2/contracts' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.CONTRACTS'})} hasBullet />
              <AsideMenuItem to='/payroll/v2/simulator' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.SIMULATOR'})} hasBullet />
              <AsideMenuItem to='/payroll/v2/runs' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.RUNS'})} hasBullet />
              <AsideMenuItem to='/payroll/v2/payslips' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.PAYSLIPS'})} hasBullet />
              {hasPayrollV2LegalDraftAccess(me?.role) ? (
                <AsideMenuItem to='/payroll/v2/pay-items' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.PAY_ITEMS'})} hasBullet />
              ) : (
                <></>
              )}
              <AsideMenuItem to='/payroll/v2/ytd' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.YTD'})} hasBullet />
              <AsideMenuItem to='/payroll/v2/legal-rules' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.LEGAL_RULES'})} hasBullet />
              <AsideMenuItem to='/payroll/v2/employer-settings' title={intl.formatMessage({id: 'PAYROLL_V2.MENU.EMPLOYER_SETTINGS'})} hasBullet />
            </AsideMenuItemWithSub>
          ) : (
            <></>
          )}

          {hasRoleAccess('/payroll-categories') ? (
            <AsideMenuItem
              to='/payroll-categories'
              icon='/media/icons/duotune/finance/fin005.svg'
              title={intl.formatMessage({id: 'MENU.PAYROLL_CATEGORIES', defaultMessage: 'Payroll Categories'})}
              fontIcon='bi-tags'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/expenditures') ? (
            <AsideMenuItem
              to='/expenditures'
              icon='/media/icons/duotune/finance/fin008.svg'
              title={intl.formatMessage({id: 'MENU.EXPENDITURES'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}

          {hasRoleAccess('/accounting') ? (
            <AsideMenuItemWithSub
              to='/accounting'
              className='accounting-aside-nav'
              icon='/media/icons/duotune/finance/fin001.svg'
              title={intl.formatMessage({id: 'MENU.ACCOUNTING'})}
              fontIcon='bi-calculator'
            >
              {hasSchoolAccountingDashboardAccess(me?.role) ? (
                <AsideMenuItem to='/accounting' title={intl.formatMessage({id: 'ACCOUNTING.DASHBOARD.TITLE'})} hasBullet exact />
              ) : (
                <></>
              )}
              {hasSchoolAccountingStudentOutstandingAccess(me?.role) ? (
                <AsideMenuItem to='/accounting/student-outstanding' title={intl.formatMessage({id: 'ACCOUNTING.STUDENT_UNPAID.TITLE'})} hasBullet />
              ) : (
                <></>
              )}
              {hasSchoolAccountingReceiptsAccess(me?.role) ? (
                <AsideMenuItem to='/accounting/payments' title={intl.formatMessage({id: 'ACCOUNTING.PAYMENTS.TITLE'})} hasBullet />
              ) : (
                <></>
              )}
              <AsideMenuItem to='/accounting/expenses' title={intl.formatMessage({id: 'ACCOUNTING.EXPENSES.TITLE'})} hasBullet />
              <AsideMenuItem to='/accounting/expenses/new' title={intl.formatMessage({id: 'ACCOUNTING.EXPENSES.NEW'})} hasBullet />
              <AsideMenuItem to='/accounting/invoice-followups' title={intl.formatMessage({id: 'ACCOUNTING.FOLLOWUPS.TITLE'})} hasBullet />
              {hasSchoolAccountingEmailTemplateAdminAccess(me?.role) ? (
                <AsideMenuItem
                  to='/accounting/invoice-followups/email-settings'
                  title={intl.formatMessage({id: 'ACCOUNTING.FOLLOWUPS.EMAIL_SETTINGS_TITLE'})}
                  hasBullet
                />
              ) : (
                <></>
              )}
              <AsideMenuItem to='/accounting/tej' title={intl.formatMessage({id: 'ACCOUNTING.TEJ.TITLE'})} hasBullet />
              {hasSchoolAccountingTicketsAccess(me?.role) ? (
                <AsideMenuItem to='/accounting/tickets' title={intl.formatMessage({id: 'ACCOUNTING.TICKETS.TITLE'})} hasBullet />
              ) : (
                <></>
              )}
              <AsideMenuItem to='/accounting/reports' title={intl.formatMessage({id: 'ACCOUNTING.REPORTS.TITLE'})} hasBullet />
              <AsideMenuItem to='/accounting/audit' title={intl.formatMessage({id: 'ACCOUNTING.AUDIT.TITLE'})} hasBullet />
            </AsideMenuItemWithSub>
          ) : (
            <></>
          )}

          {hasRoleAccess('/promotions') ? (
            <AsideMenuItem
              to='/promotions'
              icon='/media/icons/duotune/finance/fin005.svg'
              title={intl.formatMessage({id: 'MENU.PROMOTIONS'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
            {hasRoleAccess('/statistiques') ? (
              <AsideMenuItem
                to='/statistiques'
                icon='/media/icons/duotune/graphs/gra010.svg'
                title={intl.formatMessage({id: 'MENU.STATISTIQUES'})}
                fontIcon='bi-layers'
              />
            ) : (
              <></>
          )}
          {hasRoleAccess('/email-management') ? (
            <AsideMenuItem
              to='/email-management'
              icon='/media/icons/duotune/communication/com010.svg'
              title={intl.formatMessage({id: 'MENU.EMAIL_MANAGEMENT'})}
              fontIcon='bi-layers'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/file-manager') ? (
            <AsideMenuItem
              to='/file-manager'
              icon='/media/icons/duotune/files/fil013.svg'
              title={intl.formatMessage({id: 'MENU.FILE_MANAGER'})}
              fontIcon='bi-folder'
            />
          ) : (
            <></>
          )}
          {hasRoleAccess('/games') ? (
            <AsideMenuItem
              to='/games'
              icon='/media/icons/duotune/general/gen020.svg'
              title={intl.formatMessage({id: 'MENU.GAMING_PANEL'})}
              fontIcon='bi-controller'
            />
          ) : (
            <></>
          )}
          {workspace.showZadLauncher ? (
            <AsideMenuItem
              to='/zad'
              icon='/media/icons/duotune/ecommerce/ecm001.svg'
              title={intl.formatMessage({id: 'ZAD.MENU.SECTION'})}
              fontIcon='bi-journal-bookmark'
              hasArrow
            />
          ) : (
            <></>
          )}
          </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  )
}
